import React, { ComponentProps } from 'react'
import Subtitle from '../Typography/Subtitle'
import styled from 'styled-components'
import { rem } from 'polished'
import { _TextBlockIcon, TextBlockProps, _TextBlockStyle } from './_TextBlock'
import cn from 'clsx'

const TextBlock = styled(Subtitle)`
  ${_TextBlockStyle}

  &.variant-subtitle1 {
    --text-block-gap: ${rem(8)};
  }

  &.variant-subtitle2,
  &.variant-subtitle3 {
    --text-block-gap: ${rem(4)};
  }
`

interface Props extends Omit<ComponentProps<typeof Subtitle>, 'as' | 'forwardedAs'>, TextBlockProps {
}

function SubtitleTextBlock(props: Props) {
  const {
    children,
    endIcon = null,
    startIcon = null,
    fit,
    align,
    tabletAlign,
    variant,
    className,
    format,
    lineClamp,
    wrap,
    colour,
    ...rest
  } = props

  return <TextBlock
    {...rest}
    colour={colour}
    variant={variant}
    className={cn(
      className,
      fit ? `fit-${fit}` : undefined,
      align ? `align-${align}` : undefined,
      tabletAlign ? `align-on-tablet-${tabletAlign}` : undefined,
    )}
  >
    {!!startIcon && <_TextBlockIcon>{startIcon}</_TextBlockIcon>}
    <Subtitle
      variant={variant}
      format={format}
      lineClamp={lineClamp}
      wrap={wrap}
      align={align}
      tabletAlign={tabletAlign}
      colour={colour}
    >
      {children}
    </Subtitle>
    {!!endIcon && <_TextBlockIcon>{endIcon}</_TextBlockIcon>}
  </TextBlock>
}

export default SubtitleTextBlock
